/**
 * Offer version snapshot route
 *
 * Renders the read-only archival view of a published offer version. The snapshot fetch,
 * its not-found/forbidden states and the persisted per-unit decisions live in
 * OfferVersionSnapshotPage (@ooh/screens) — no live draft endpoints are called.
 *
 * Traceability: REQ-7.6 → offer-versioning / Read-only Snapshot View UI
 */
import * as React from 'react';
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { OfferVersionSnapshotPage } from '@ooh/screens';
import { PageTitleContext } from '../__root';

export const Route = createFileRoute('/offers/$offerId/versions/$versionId')({
  component: OfferVersionSnapshotRoute,
});

export function OfferVersionSnapshotRoute() {
  const { offerId, versionId } = useParams({ from: '/offers/$offerId/versions/$versionId' });
  const navigate = useNavigate();
  const { setPageTitle } = React.useContext(PageTitleContext);

  function openUnitDetail(mediaUnitId: number) {
    void navigate({
      to: '/offers/$offerId/units/$unitId',
      params: { offerId, unitId: String(mediaUnitId) },
      search: { from: `version:${versionId}` },
    });
  }

  return (
    <OfferVersionSnapshotPage
      offerId={offerId}
      versionId={versionId}
      onOpenUnitDetail={openUnitDetail}
      onTitleChange={setPageTitle}
    />
  );
}
